import { Component, OnInit } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { ToasterService } from 'angular2-toaster';
import { GeneralConstants } from '../../shared/general.constants';
import * as _ from 'lodash';
import {VideoTitlesService} from './video-titles.service';
import {VideoService} from '../model/video.service';
import {CatalogService} from '../../catalogue/catalog-api/catalog.service';

const DEBOUNCE_TIME = 500;
const ES_RESULTS_SIZE = 20;
const ES_LARGER_SEARCH_AMOUNT = 100;

const PAGE_SIZE = 100;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'video-titles',
    templateUrl: 'video-titles.component.html',
    styleUrls: ['video-titles.component.scss']
})
export class VideoTitlesComponent implements OnInit {
    // Navigation
    private navIndex = 0;


    private ES_QUERY_OBJECT = {

        'page' : '',
        'size' : '',

        'query': {
            'parrot_id' : '',
            'title' : '',
            'catalog_state' : '',
            'start_date' : '',
            'end_date' : '',
            'content_type' : ''
        },
        'sort' : '',
        'sort_direction' : ''

    };
    

    // Checkboxes
    private checkboxes = {
        clientReady: true,
        demandGeneration: true,
        harvested: false,
        requested: false,
    };
    private shouldDoSearch = false;

    // Checkboxes and values for original country/language/network filters
    private sortNSearchCriteriaCheckboxes = {
        byDate: true,
        byParrotid: false,
        byTitle: false,
        sortState: true,
        sortDirection: true
    };
    private countrySubject = new Subject<string>();
    private originalCountry = '';
    private languageSubject = new Subject<string>();
    private byParrotIdSearch = '';
    private networkSubject = new Subject<string>();
    private byTitleSearch = '';
    private catalogStates = ['client_ready', 'demand_generation'];
    private sortValues = ['Total Number of Views', 'Release Date', 'Total Number of Videos',  'Total Number of Unverified Videos'];
    private sortDirectionValues = ['Descending', 'Ascending'];
    private catalogStateSubject = new Subject<string>();
    private sortByState = 'total_number_of_views';
    private sortDirectionValue = 'desc';
    private contentType = 'tv';

    private page = 1;
    private maxPages;



    // Subject for search debounce and search value
    private subject = new Subject<string>();
    private searchValue = '';

    private searchLoading = false;

    private results = [];

    private selectedShow;

    private createTitleRequests = false;

    private totalResults = 0;
    private totalResultsImdb = 0;
    private from = 0;
    private largerSearch = false;
    private hasMore = false;
    private categoryType: number = 1;
    private categoryTypeValue = 'movie';

    private startDate = new Date();
    private endDate = new Date();
    private maxDate = new Date();
    private loadingVideos = false;


    constructor(private videoService: VideoService, private catalogService: CatalogService,
        private toasterService: ToasterService,
        private generalConstants: GeneralConstants) {

        this.startDate = new Date(this.startDate.setDate(this.startDate.getDate() - 366));
        this.endDate = new Date(this.endDate.setDate(this.endDate.getDate() + 366));
    }

    ngOnInit() {
        this.countrySubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(country => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.languageSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(language => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.networkSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(network => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.catalogStateSubject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged()
            .subscribe(catalogState => {
                this.shouldDoSearch = true;
                this.subject.next(this.searchValue);
            });
        this.subject.debounceTime(DEBOUNCE_TIME)
            .distinctUntilChanged((prev, curr) => prev === curr && !this.shouldDoSearch)
            .subscribe(searchValue => {
                // Search value has changed, reset results, total results and from
                this.results = [];
                this.totalResultsImdb = 0;
                this.totalResults = 0;
                this.from = 0;
                this.doSearch(searchValue);
            });
    }



    doSearch(searchValue) {
        this.shouldDoSearch = false;
        this.searchLoading = true;
        const typeFilters = Object.keys(this.checkboxes)
            .filter(item => item !== 'extended' && this.checkboxes[item]);
        const originalFilters = {};
        if (this.sortNSearchCriteriaCheckboxes.byDate && this.originalCountry && this.originalCountry !== '') {
            originalFilters['data.original_country.*'] = this.originalCountry;
        }
        if (this.sortNSearchCriteriaCheckboxes.byTitle && this.byParrotIdSearch && this.byParrotIdSearch !== '') {
            originalFilters['data.original_language.*'] = this.byParrotIdSearch;
        }
        if (this.sortNSearchCriteriaCheckboxes.byParrotid && this.byTitleSearch && this.byTitleSearch !== '') {
            originalFilters['data.original_network.*'] = this.byTitleSearch;
        }
        if (this.sortNSearchCriteriaCheckboxes.sortState && this.sortByState && this.sortByState !== '') {
            originalFilters['catalog_state'] = this.sortByState;
        }
        // If there are original filters, but no search value, use an unlimited (very large) search size
        this.largerSearch = false;
        if (Object.keys(originalFilters).length > 0 && searchValue === '') {
            this.largerSearch = true;
        }
        const queryJSON = this.catalogService.createEsQuery(
            searchValue, this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE, typeFilters, originalFilters,
            this.catalogService.getEsDefaultSource(), 'catalog', this.from
        );
        // tslint:disable-next-line:comment-format
        //console.log(queryJSON);
        // if (this.checkboxes.extended) {
        //     // Call master_catalog metadata and imdb_titles general_info indexes
        //     const imdbTypeFilters = typeFilters.map((item) => {
        //         if (item === 'show') {
        //             return 'tvSeries';
        //         } else if (item === 'movie') {
        //             return 'movie';
        //         } else {
        //             return null;
        //         }
        //     }).filter((item) => item);
        //     // Always call the metadata search, even if there are no more results
        //     const functionsToPromise = [this.catalogService.callEsProxyCustomQuery(
        //         queryJSON,
        //         'master_catalog'
        //     )];
        //     if (this.totalResultsImdb > this.from || this.totalResultsImdb === 0) {
        //         const imdbQueryJSON = this.catalogService.createEsQuery(
        //             searchValue, ES_RESULTS_SIZE, imdbTypeFilters, null, [
        //             'AKAs',
        //             'Countries',
        //             'ResourceId',
        //             'PlotSummary',
        //             'ProductionCompanies',
        //             'Title',
        //             'Year'
        //         ],
        //             'imdb', this.from
        //         );
        //         functionsToPromise.push(this.catalogService.callEsProxyCustomQuery(
        //             imdbQueryJSON,
        //             'imdb_metadata'
        //         ));
        //     }
        //     Promise.all(functionsToPromise)
        //         .then((res) => {
        //             let results = res[0].hits.hits.map(this.catalogService.mapEsResultItem);
        //             if (res[1]) {
        //                 const imdbResArray = res[1].hits.hits.map(this.catalogService.mapEsImdbResultItem)
        //                     .filter(item => !item.parrotId);
        //                 this.totalResultsImdb = res[1].hits.total;
        //                 results = results.concat(
        //                     imdbResArray
        //                 );
        //             }
        //             this.totalResultsMetadata = res[0].hits.total;
        //             this.results = this.results.concat(results);
        //             const pageSize = this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE;
        //             if (this.totalResultsMetadata > (this.from + pageSize) || this.totalResultsImdb > (this.from + pageSize)) {
        //                 this.hasMore = true;
        //             } else {
        //                 this.hasMore = false;
        //             }
        //             this.searchLoading = false;
        //         })
        //         .catch((err) => {
        //             console.error('Failed to call the ES proxy in the catalog API' + err.toString());
        //             this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
        //             this.searchLoading = false;
        //         });
        // }
             {

            let index;

            if (true) {
                index = 'series_metadata';
            }
            if (this.contentType === 'movie') {
                index = 'movie_metadata';

            }
            if (this.contentType === 'talent') {
                index = 'talent_metadata';

            }

            const queryJSONNew = '{\n' +
                '  "query": {\n' +
                '    "bool": {\n' +
                '      "must": [\n' +
                '        {\n' +
                '          "multi_match": {\n' +
                '            "query": "game of thrones",\n' +
                '            "type": "best_fields",\n' +
                '            "fields": [\n' +
                '              "title",\n' +
                '              "display_name",\n' +
                '              "parrot_id",\n' +
                '              "data.also_known_as^1.3",\n' +
                '              "data.external_mappings.*",\n' +
                '              "extended.tms.tms_id",\n' +
                '              "extended.wiki.wikibase_id",\n' +
                '              "extended.wiki.langlinks.title",\n' +
                '              "extended.wiki.langlinks.url",\n' +
                '              "extended.wiki.title"\n' +
                '            ],\n' +
                '            "minimum_should_match": 1,\n' +
                '            "fuzziness": 0.5,\n' +
                '            "prefix_length": 3,\n' +
                '            "slop": 3\n' +
                '          }\n' +
                '        }\n' +
                '      ]\n' +
                '    }\n' +
                '  },\n' +
                '  "timeout": "7s",\n' +
                '  "_source": [\n' +
                '    "title",\n' +
                '    "parrot_id",\n' +
                '    "display_name",\n' +
                '    "catalog_state",\n' +
                '    "internal_data",\n' +
                '    "data.release_year",\n' +
                '    "data.type",\n' +
                '    "data.original_country",\n' +
                '    "data.original_network",\n' +
                '    "data.original_language",\n' +
                '    "data.short_description",\n' +
                '    "data.also_known_as",\n' +
                '    "data.external_mappings",\n' +
                '    "data.genre_tags",\n' +
                '    "data.total_seasons",\n' +
                '    "data.total_episodes"\n' +
                '  ],\n' +
                '  "size": 20,\n' +
                '  "from": 0\n' +
                '}';

            this.catalogService.callEsProxyCustomQuery(
                queryJSONNew,
                index,
            ).then((res) => {
                // this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapEsResultItem));
                this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, this.contentType)));
                this.totalResults = res.hits.total.value;
                const pageSize = this.largerSearch ? ES_LARGER_SEARCH_AMOUNT : ES_RESULTS_SIZE;
                if (this.totalResults > (this.from + pageSize)) {
                    this.hasMore = true;
                } else {
                    this.hasMore = false;
                }
                this.searchLoading = false;
            }).catch((err) => {
                console.error('Failed to call the ES proxy in the catalog API' + err.toString());
                this.toasterService.pop('error', 'Failed to call the ES proxy in the catalog API');
                this.searchLoading = false;
            });
        }
    }

    handleLoadMore() {

            this.page = this.page + 1;
            this.handleSubmit();

    }

    handleNavSelect(index) {
        this.navIndex = index;
    }

    handleCatalogStateCheckbox(checkboxName, checked: any) {

        this.catalogStates = [];

        if (checked) {
            this.catalogStates.push(checkboxName);
        }




        // Check that there will be at least one checkbox selectd
        // const willBeCheckboxSelected = Object.keys(this.checkboxes)
        //     .map(item => [item, this.checkboxes[item]])
        //     .filter(item => item[1] && item[0] !== checkboxName && item[0] !== 'extended')
        //     .length > 0;
        // if (willBeCheckboxSelected) {
        //
        //     if(checkboxName === 'movie' && !this.checkboxes.movie){
        //         this.contentType = 'movie';
        //     }
        //     if(checkboxName === 'show' && !this.checkboxes.show){
        //         this.contentType = 'tv';
        //     }
        //     if(checkboxName === 'talent' && !this.checkboxes.talent){
        //         this.contentType = 'talent';
        //     }
        //
        //     setTimeout(() => {
        //         this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];
        //         this.shouldDoSearch = true;
        //         if (this.searchValue) {
        //             this.subject.next(this.searchValue);
        //         }
        //     });
        // } else {
        //     this.toasterService.pop('info', 'There must be at least one filter checkbox selected!');
        // }
    }

    handleOriginalFiltersCheckboxes(checkboxName) {
        this.sortNSearchCriteriaCheckboxes[checkboxName] = !this.sortNSearchCriteriaCheckboxes[checkboxName];
        // If a recently enabled checkbox has text, do a search.)
        if (this.shouldSearch()) {
            switch (checkboxName) {
                case 'byParrotid':
                    if (this.byParrotIdSearch && this.byParrotIdSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'byTitle':
                    if (this.byTitleSearch && this.byTitleSearch !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'country':
                    if (this.originalCountry && this.originalCountry !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
                case 'catalogState':
                    if (this.sortByState && this.sortByState !== '') {
                        this.shouldDoSearch = true;
                    }
                    break;
            }
        } else {
            // If all filters are disabled, set the table data to empty
            this.results = [];
        }
    }

    //MAKE THE NEW CALL HERE
    handleOpen(result) {

        if (!this.selectedShow || (this.selectedShow && this.selectedShow.parrot_id !== result.parrotId)) {
            this.selectedShow = {
                parrot_id: result.parrot_id,
                title: result.title,
                displayName: result.displayName,
                catalog_state: result.catalogState,
                original_country: result.original_country,
                original_language: result.original_language,
                start_date: result.start_date,
                release_year: result.release_year,
                imdb_id: result.imdb_id,
                wikibase_id: result.wikibase_id,
                content_type: result.contentType
            };
        } else if (this.selectedShow && this.selectedShow.parrot_id === result.parrotId) {
            // Trigger a change for the property
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: undefined,
                    catalog_state: 'client_ready',
                    title: undefined,
                    content_type: undefined,
                    display_name: undefined
                };
            });
            setTimeout(() => {
                this.selectedShow = {
                    parrot_id: result.parrot_id,
                    title: result.title,
                    displayName: result.displayName,
                    catalog_state: result.catalog_state,
                    original_country: result.original_country,
                    original_language: result.original_language,
                    start_date: result.start_date,
                    release_year: result.release_year,
                    imdb_id: result.imdb_id,
                    wikibase_id: result.wikibase_id,
                    content_type: result.contentType
                };
            });
        }
    }

    handleCreateTitle() {
        this.createTitleRequests = true;
        setTimeout(() => {
            this.createTitleRequests = false;
        }, 1000);
    }

    onKeyUp(searchValue) {
        this.searchValue = searchValue;
        if (this.shouldSearch()) {
            this.subject.next(searchValue);
        } else {
            this.results = [];
        }
    }

    onOriginalKeyUp(value, type) {
        switch (type) {
            case 'byParrotid':
                this.byParrotIdSearch = value;
                this.handleSubmit();
                break;
            case 'byTitle':
                this.byTitleSearch = value;
                this.handleSubmit();
                break;
            case 'byDate':
                break;
            case 'sortState':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if ( value === 'Release Date' ) {
                        value = 'release_date';
                    } else if ( value === 'Total Number of Videos' ) {
                        value = 'total_number_of_videos';
                    } else if ( value === 'Total Number of Views' ) {
                        value = 'total_number_of_views';
                    } else if ( value === 'Total Number of Unverified Videos' ) {
                        value = 'total_number_of_unverified_videos';
                    }
                    this.sortByState = value;
                }
                break;
            case 'sortDirection':
                if (value) {
                    // 'Release Date', 'Total Number of Videos', 'Total Number of Views', 'Total Number of Unverified Videos'
                    if ( value === 'Ascending') {
                        value = 'asc';
                    } else if ( value === 'Descending' ) {
                        value = 'desc';
                    }
                    this.sortDirectionValue = value;
                }
                break;
        }
    }

    shouldSearch() {
        return this.searchValue || (this.sortNSearchCriteriaCheckboxes.byDate ||
            this.sortNSearchCriteriaCheckboxes.byParrotid || this.sortNSearchCriteriaCheckboxes.byTitle);
    }

    onCategoryTypeChange(value: number) {
        this.categoryType = value;

        if (value === 1) {
            this.categoryTypeValue = 'movie';
        } else {
            this.categoryTypeValue = 'tv';

        }
    }

    handleNextPage() {
        this.handleGoToPage(this.page + 1);
    }

    handlePreviousPage() {
        this.handleGoToPage(this.page - 1);
    }

    handleFirstPage() {
        this.handleGoToPage(1);
    }

    handleLastPage() {
        this.handleGoToPage(this.maxPages);
    }

    handleGoToPage(page) {
        this.page = page;
    }

    handleSubmit() {

        this.results = [];
        this.loadingVideos = true;

        // console.log(this.page);
        // console.log(PAGE_SIZE);
        // console.log(this.byParrotIdSearch);
        // console.log(this.byTitleSearch);
        // console.log(this.startDate);
        // console.log(this.endDate);
        // console.log(this.categoryTypeValue);
        // console.log(this.sortByState);
        // console.log(this.catalogStates);
        // console.log(this.sortDirectionValue);

        const searchQuery = this.createSearchQuery();
        this.videoService.getSearchVideoResults(
            searchQuery,
        ).then((res) => {

            console.log(res);
            this.results = this.results.concat(res.result.map(item => this.videoService.mapVideoResultItem(item)));
            this.totalResults = res.page_info.maxpage;
            if (this.totalResults > (this.page)) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
            this.loadingVideos = false;
        }).catch((err) => {
            console.error('Failed to get video results in the catalog API' + err.toString());
            this.toasterService.pop('error', 'Failed to get video results');
            this.loadingVideos = false;
        });



        // this.doSearch('game of thrones');

        // this.loadingVideos = false;








    }

    createSearchQuery () {
        const requestQuery =  _.cloneDeep(this.ES_QUERY_OBJECT);
        // console.log(this.page);
        // console.log(PAGE_SIZE);
        // console.log(this.byParrotIdSearch);
        // console.log(this.byTitleSearch);
        // console.log(this.startDate);
        // console.log(this.endDate);
        // console.log(this.categoryTypeValue);
        // console.log(this.sortByState);
        // console.log(this.catalogStates);

        const startDate = this.startDate.toISOString().slice(0, 10);
        const endDate = this.endDate.toISOString().slice(0, 10);


        requestQuery.page = this.page;
        requestQuery.size = PAGE_SIZE;

        if (this.sortNSearchCriteriaCheckboxes.byParrotid) {
            requestQuery.query.parrot_id = this.byParrotIdSearch;
        }
        if (this.sortNSearchCriteriaCheckboxes.byTitle) {
            requestQuery.query.title = this.byTitleSearch;
        }
        if (this.sortNSearchCriteriaCheckboxes.byDate) {
            requestQuery.query.start_date = startDate;
            requestQuery.query.end_date = endDate;
        }

        requestQuery.query.content_type = this.categoryTypeValue;
        requestQuery.query.catalog_state = this.catalogStates;
        requestQuery.sort = this.sortByState;
        requestQuery.sort_direction = this.sortDirectionValue;

        // console.log(JSON.stringify(requestQuery));
        return JSON.stringify(requestQuery);


    }
          // ' {\n' +
          //   '  "page" : <int>,\n' +
          //   '  "size" : <int>,\n' +
          //   '  "query" : {\n' +
          //   '      "parrot_id" : "<opt_pid>",\n' +
          //   '      "title" : "<opt_title>",\n' +
          //   '      "catalog_state" : ["client_ready", "demand_generation"],\n' +
          //   '      "start_date" : "<opt_yyyy-mm-dd>",\n' +
          //   '      "end_date" : "<opt_yyyy-mm-dd>",\n' +
          //   '      "category" : ["movie"]\n' +
          //   '  },\n' +
          //   '  "sort" : "<sort_opt_name>"\n' +
          //   '}'
    public pieChartLabels: string[] = ['Approved', 'Rejected', 'Pending'];
    // tslint:disable-next-line:member-ordering
    public pieChartLabelsCB: string[] = ['Low', 'Medium', 'High'];
    // tslint:disable-next-line:member-ordering
    public pieChartData: number[] = [600708, 27947, 1227607];
    // tslint:disable-next-line:member-ordering
    public pieChartDataCB: number[] = [600708, 27947, 1227607];
    // tslint:disable-next-line:member-ordering
    public pieChartType: string = 'pie';

    // tslint:disable-next-line:member-ordering
    public totalNumberOfVideos = 1000000;

    // tslint:disable-next-line:member-ordering
    pieChartColor: any = [
        {
            backgroundColor: ['rgba(30, 169, 224, 0.8)',
                'rgba(255,165,0,0.9)',
                'rgba(139, 136, 136, 0.9)',

            ]
        }
    ];

    public chartClicked(e: any): void {
        console.log(e);
    }

    public chartHovered(e: any): void {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/video-search/video-titles.component.ts